import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feedback-dialog" }
const _hoisted_2 = { class: "feedback-dialog__header" }
const _hoisted_3 = { class: "feedback-dialog__buttons" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "feedback-dialog__close icon-close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('FeedbackModal.header')), 1),
    _createElementVNode("form", {
      class: "feedback-dialog__form",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
      autocomplete: "off"
    }, [
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "Vaše hodnotenie",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.message.$model) = $event)),
        name: "frm-feedback_message"
      }, null, 512), [
        [_vModelText, _ctx.v$.form.message.$model]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "button-dismiss button",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _toDisplayString(_ctx.$t('FeedbackModal.later')), 1),
        _createElementVNode("button", {
          class: "button-submit button",
          disabled: !_ctx.form.message
        }, _toDisplayString(_ctx.$t('FeedbackModal.send')), 9, _hoisted_4)
      ])
    ], 32)
  ]))
}